import { baseColors } from "@Constants/baseStyles"
import * as React from "react"
import Svg, { G, Path, Defs, ClipPath } from "react-native-svg"

function SvgFichePatientIcon(props) {
    return (
        <Svg xmlns="http://www.w3.org/2000/svg" width={27} height={27} fill="none" viewBox="0 0 27 27" {...props}>
            <G clipPath="url(#clip0)">
                <Path
                    fill={baseColors.orange.primary}
                    d="M24.383 7.935c.29 0 .527.236.527.527V13.5l-4.759 5.305-.21-7.238 1.789-3.632h2.653zM5.432 8.73L3.18 13.5l.826 7.42-3.711 5.133a.105.105 0 01-.191-.061L.003 5.285a.527.527 0 01.527-.53h2.65L5.432 8.73z"
                />
                <Path fill="#DCEAEC" d="M21.73.78v14.31h-9.275l-2.158-7.65L12.455.78h9.275z" />
                <Path fill="#DCEAEC" d="M3.18.78h9.275v14.31H3.18V.78z" />
                <Path
                    fill="#00B5BC"
                    d="M14.31 11.973v2.322h-1.855l-.67-2.727.67-2.437.938.82c.583.51.917 1.247.917 2.022z"
                />
                <Path
                    fill={baseColors.green.pastel}
                    d="M12.455 9.131v5.164H6.36v-2.322c0-.774.335-1.511.917-2.021l1.7-1.487h2.717l.761.666z"
                />
                <Path
                    fill="#00B5BC"
                    d="M14.575 4.487c0-.29.236-.527.527-.527h3.45c.292 0 .528.236.528.527v.536a.527.527 0 01-.527.527h-3.45a.527.527 0 01-.528-.527v-.536zm1.59 3.18c0-.29.236-.527.527-.527h1.86c.292 0 .528.236.528.527v.536a.527.527 0 01-.527.527h-1.86a.527.527 0 01-.528-.527v-.536z"
                />
                <Path
                    fill="#FFD298"
                    d="M12.985 6.61v1.06c0 .595-.197 1.145-.53 1.588l-.67-1.901.67-2.336c.333.444.53.994.53 1.589z"
                />
                <Path
                    fill="#FFE3C1"
                    d="M12.455 5.022v4.236a2.648 2.648 0 01-4.77-1.588V6.61a2.648 2.648 0 014.77-1.588z"
                />
                <Path
                    fill={baseColors.orange.primary}
                    d="M26.317 13.5c.345 0 .598.327.51.661l-3.055 11.666a.527.527 0 01-.51.394H12.455l-1.613-5.724 1.613-6.996h13.862z"
                />
                <Path
                    fill="#EB6800"
                    d="M12.455 13.5v12.721H.338a.264.264 0 01-.256-.328L3.08 13.9c.059-.235.27-.4.512-.4h8.863z"
                />
            </G>
            <Defs>
                <ClipPath id="clip0">
                    <Path fill="#fff" d="M0 0h27v27H0z" />
                </ClipPath>
            </Defs>
        </Svg>
    )
}

export default SvgFichePatientIcon
